import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BulkImportInitResponse } from '@dr-customer-offers-ui/lib-interfaces';
import { CookieService } from 'ngx-shared-services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BulkUploadFileService {
  private file: File | null = null;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) {}

  set(file: File): void {
    this.file = file;
  }

  clear(): void {
    this.file = null;
  }

  upload(initResponse: BulkImportInitResponse): Observable<HttpEvent<void>> | null {
    if (!this.file) {
      return null;
    }
    const enocCookie = this.cookieService.getCookie('enoc_session');
    const headers = new HttpHeaders({
      'x-amz-meta-import-id': initResponse.import_id,
      'x-amz-meta-user-id': initResponse.user_id,
      'x-amz-meta-x-enelx-trace-id': initResponse.trace_id,
      'x-amz-meta-enoc-session': enocCookie
    });
    return this.http.put<void>(initResponse.url, this.file, { headers, reportProgress: true, observe: 'events' });
  }
}
